import type { PromoCodeState } from '../hooks/usePromoCode'

interface Props {
	promo: PromoCodeState
	disabled?: boolean
}

/**
 * «Есть промокод?» на оплате (тарифы, докупка токенов). Свёрнуто — ссылкой,
 * чтобы не отвлекать от оплаты; код из ссылки ?promo= раскрывает сразу.
 * Цены и бонус показывает сама модалка оплаты (из promo.quote) — здесь только
 * код, его суть и ошибки.
 */
export default function PromoCodeField({ promo, disabled }: Props) {
	const { open, input, applied, quote, error, pending, activating, activated } = promo
	if (!promo.available) return null

	if (!open) {
		return (
			<div className="promo-field">
				{activated && <PromoActivated credited={activated.credited} />}
				<button type="button" className="promo-field__toggle" onClick={() => promo.setOpen(true)} disabled={disabled}>
					Есть промокод?
				</button>
			</div>
		)
	}

	if (quote) {
		return (
			<div className="promo-field">
				<div className="promo-field__applied">
					<span className="promo-field__code">{quote.code}</span>
					<span className="promo-field__summary">{quote.summary}</span>
					<button type="button" className="promo-field__remove" onClick={promo.remove} disabled={disabled}>
						Убрать
					</button>
				</div>
			</div>
		)
	}

	return (
		<div className="promo-field">
			{activated && <PromoActivated credited={activated.credited} />}
			<form
				className="promo-field__row"
				onSubmit={(e) => {
					e.preventDefault()
					promo.apply()
				}}
			>
				<input
					className="promo-field__input"
					type="text"
					value={input}
					onChange={(e) => promo.setInput(e.target.value)}
					placeholder="Промокод"
					aria-label="Промокод"
					autoComplete="off"
					autoCapitalize="characters"
					spellCheck={false}
					maxLength={50}
					disabled={disabled}
				/>
				<button type="submit" className="promo-field__btn" disabled={disabled || pending || !input.trim()}>
					{pending ? 'Проверяем…' : 'Применить'}
				</button>
			</form>
			{error && (
				<div className="promo-field__msg promo-field__msg--error">
					<span>{error.message}</span>
					{/* Код на бонусные токены покупки не требует — активируем тут же */}
					{error.reason === 'activation_only' && (
						<button type="button" className="promo-field__action" onClick={() => void promo.activate()} disabled={activating}>
							{activating ? 'Активируем…' : 'Активировать'}
						</button>
					)}
					{applied && error.reason !== 'activation_only' && (
						<button type="button" className="promo-field__action" onClick={promo.remove}>
							Убрать
						</button>
					)}
				</div>
			)}
		</div>
	)
}

function PromoActivated({ credited }: { credited: number }) {
	return (
		<div className="promo-field__msg promo-field__msg--ok">
			Начислено {credited.toLocaleString('ru-RU')} токенов по промокоду
		</div>
	)
}
